import React from 'react';
import { Form } from '../../../ui/universe';
import { getSelectRectKey, getWarnList } from '../utils';

/**
 * Warn 渲染器 - 告警信息展示
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.config - 结果配置
 * @param {string} props.selectRect - 当前选中的矩形 key
 * @param {Function} props.onSelect - 选中回调
 */
const WarnRenderer = ({ params, config, selectRect, onSelect }) => {
  const warnList = getWarnList(params);

  if (warnList.length === 0) {
    return <div style={{ paddingLeft: '22px', paddingTop: '10px' }}>未检测到待告警信息</div>;
  }

  return (
    <>
      {warnList.map((item, index) => {
        const selectRectVal = getSelectRectKey({
          data: item,
          key: '',
          valStr: `${item.key}-${item[config.riskNum]}`
        });
        const warnLabel = config.warnsList?.[item.key] || item.key;

        return (
          <Form.Item
            key={`warn-${index}`}
            active
            label={`告警${index + 1}`}
            className={`${selectRect && selectRect === selectRectVal ? 'isSelect' : ''} unv-form__item-group`}
            onClick={() => {
              onSelect && onSelect(item.key, selectRectVal);
            }}
          >
            <p className="mb-10">
              <span>告警类型:</span>
              <span>{warnLabel}</span>
            </p>
            {item[config.secondField] && (
              <p className="mb-10">
                <span>特殊判定:</span>
                <span>{item[config.secondField]}</span>
              </p>
            )}
          </Form.Item>
        );
      })}
    </>
  );
};

export default WarnRenderer;
